import React from 'react'
import { useNavigate } from 'react-router-dom'
import { SubscriptionFeatureList } from './SubscriptionFeatureList'
import { subscriptionCardBigIF } from './subscriptionCardBigIF'

export const SubscriptionCardBig = ({
  card,
}: {
  card: subscriptionCardBigIF
}) => {
  const navigate = useNavigate()

  const handleSubscribeClick = (path: string) => {
    navigate(path)
  }

  return (
    <div className='flex justify-start text-left rounded-xl shadow-equal-all-sides'>
      <div className={`w-[13px] ${card.tabColor} rounded-l-lg`} />

      <div className='flex-1 flex-col p-4 sm:px-[30px] sm:py-[20px]'>
        <h4 className='text-center sm:text-left text-sm sm:text-2xl font-medium sm:font-bold tracking-wide pb-4'>
          {card.title}

          <hr className='max-w-[300px] border-[#B8E0DB] mt-1' />
        </h4>

        <h5 className='text-[#205497] text-sm sm:text-base font-normal sm:font-bold pb-2'>
          {card.subTitle}
        </h5>

        <div className='flex flex-col md:flex-row md:justify-between md:items-end gap-5 md:gap-0'>
          <div className='flex flex-col'>
            <div className='flex items-end font-medium sm:font-bold gap-1'>
              <span className='text-[#101828] text-base sm:text-[32px] sm:pb-2'>
                {card.amount}

                {card.vatAddition && (
                  <span className='text-xs sm:text-base'>+ VAT</span>
                )}
              </span>

              {card.recurrence && (
                <span className='text-[#6E7785] text-xs sm:text-base'>
                  {card.recurrence}
                </span>
              )}
            </div>

            {card.dueOnReceiptOfClientPayment && (
              <p className='text-[#6E7785] text-xs sm:text-base font-medium sm:font-bold'>
                Due on receipt of client payment
              </p>
            )}
          </div>
          <div className='px-[12px] py-[6px] bg-[#020251] text-center rounded-md sm:rounded-lg'>
            <button
              className='w-full h-full text-white hover:text-[#65C2D7] text-xs sm:text-base'
              onClick={() => handleSubscribeClick(card.buttonLink)}
            >
              {card.buttonLabel}
            </button>
          </div>
        </div>

        <div className='mt-[40px]'>
          {card.featureList.title && (
            <span className='text-sm sm:font-bold'>
              {card.featureList.title}
            </span>
          )}

          <SubscriptionFeatureList
            alternateColor={true}
            startColorOdd={false}
            color='bg-[#F4F4F4]'
            featureList={card.featureList.features}
          />
        </div>
      </div>
    </div>
  )
}
